<template>
  <v-dialog v-model="show" width="unset">
    <v-card class="text-left bill-of-materials">
      <v-card-title
        class="headline grey lighten-2"
        primary-title
        >
        Bill of materials
      </v-card-title>

      <v-list-item v-for="entry in billOfMaterials" :key="entry.tileRef">
        <v-list-item-content>
          <div>
            <Tile :tile-ref="entry.tileRef"
                  />
            <v-list-item-title :title="tileRefs[entry.tileRef].collection + ' ' + tileRefs[entry.tileRef].reference" class="tile-name">
              {{tileRefs[entry.tileRef].collection}}
              {{tileRefs[entry.tileRef].reference}}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ numberFormat.format(entry.count) }} fichas
            </v-list-item-subtitle>
          </div>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary"
               text
               @click="show = false"
               >
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import designService from '../services/design.service';
import Tile from '../components/Tile.vue';

export default {
  name: 'bill-of-materials',
  components: {
    Tile
  },
  props: [
    'value',
  ],
  data() {
    return {
      billOfMaterials: [],
      tileRefs: {},
      show: this.value,
      numberFormat: new Intl.NumberFormat(),
    };
  },
  watch: {
    value(val) {
      if (!val) {
        return;
      }
      this.show = true;
      this.billOfMaterials = designService.getBillOfMaterials();
      const design = designService.getCurrentDesign();
      this.tileRefs = design ? design.tileRefs : {};
    },
    show(val) {
      if (!val) {
        this.$emit('input', false);
      }
    }
  },
}
</script>

<style scoped>
.bill-of-materials .tile {
  float: left;
  width: 2.5em;
  margin-right: 5px;
}

.bill-of-materials .tile-name {
  margin-left: 2.5em;
}
</style>
